'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

const ApplySection = () => {
  const translate = useTranslate('dac7-2024.apply')
  const asset = useAsset('/assets/landing-pages/dac7')

  const imageSrc = asset('Image-Desktop-DAC7-V2.png')
  const imageSrc2x = asset('Image-Desktop-DAC7-V2@2x.png')
  const imageSrc3x = asset('Image-Desktop-DAC7-V2@3x.png')
  const imageSrcSet = `${imageSrc} 1x, ${imageSrc2x} 2x, ${imageSrc3x} 3x`

  const imageSrcMobile = asset('Image-Mobile-DAC7-V2.png')
  const imageSrc2xMobile = asset('Image-Mobile-DAC7-V2@2x.png')
  const imageSrc3xMobile = asset('Image-Mobile-DAC7-V2@3x.png')
  const imageSrcSetMobile = `${imageSrcMobile} 1x, ${imageSrc2xMobile} 2x, ${imageSrc3xMobile} 3x`

  return (
    <section className="dac7__apply" data-testid="apply-section">
      <div className="dac7__apply-image u-desktops-only">
        <Image src={imageSrc} srcset={imageSrcSet} scaling={Image.Scaling.Cover} loading="lazy" />
      </div>
      <div className="dac7__apply-text-container">
        <h2 className="dac7__apply-title">{translate('title')}</h2>
        <div className="dac7__apply-image u-mobiles-only">
          <Image
            src={imageSrcMobile}
            srcset={imageSrcSetMobile}
            scaling={Image.Scaling.Cover}
            loading="lazy"
          />
        </div>
        <p
          className="dac7__apply-description"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: translate('description') }}
        />
      </div>
    </section>
  )
}

export default ApplySection
